import * as React from "react";
function SvgPinterest(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M17.48 4.05a7.93 7.93 0 011.2.22 9.52 9.52 0 015.41 3.34 8.81 8.81 0 011.6 3.21A10.18 10.18 0 0126 12a13.06 13.06 0 010 2.34c0 .15-.05.29-.07.43a11.37 11.37 0 01-1.4 4.08 8.39 8.39 0 01-3.38 3.25 7.08 7.08 0 01-2.44.71 5.12 5.12 0 01-2.76-.4 3.75 3.75 0 01-1.65-1.39c-.27 1-.54 2-.76 2.92a13.73 13.73 0 01-1.56 3.9c-.21.37-.39.75-.58 1.12h-.26a3.42 3.42 0 00-.34-.13c-.28-.09-.5-.21-.5-.56 0-.52-.06-1-.06-1.57a13.78 13.78 0 01.08-2.23c.19-1.14.5-2.27.77-3.4l1.07-4.44a1 1 0 000-.55 5.75 5.75 0 01-.26-3.45 3 3 0 012.39-2.55 1.88 1.88 0 011.72.6 2.64 2.64 0 01.41 2.32c-.27 1.18-.64 2.34-1 3.51a4.62 4.62 0 00-.32 2 2.17 2.17 0 001.06 1.55 2.88 2.88 0 002.51.18 4.8 4.8 0 002.76-2.49 8.41 8.41 0 00.92-3 8.72 8.72 0 00-.07-3.22A5.82 5.82 0 0020 8a7 7 0 00-5-1.2 7.47 7.47 0 00-2.71.81 6.67 6.67 0 00-3.11 3.58 6.78 6.78 0 00-.39 3.12 5.94 5.94 0 001.14 3 .42.42 0 01.11.28c-.13.63-.28 1.26-.45 1.88-.06.23-.2.34-.48.2a4.28 4.28 0 01-1.68-1.48A8 8 0 016 12.73a10.76 10.76 0 01.58-2.63 8.75 8.75 0 013.36-4.26 9.44 9.44 0 014-1.59c.36-.06.71-.16 1.07-.2a14.32 14.32 0 012.47 0z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPinterest);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
